<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card :header="cardTitle" v-if="promocao" class="card-edicao">
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Titulo" class="mt-3">
            <b-form-input v-model="promocao.titulo" />
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Descrição" class="mt-3">
            <b-form-input v-model="promocao.descricao" />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Inicial" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datainicial"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesStart"
              :key="disabledDatesStart != null"
              @selected="mudaDataInicial"
              v-if="datainicial != null"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Final" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datafinal"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesEnd"
              :key="disabledDatesEnd != null"
              @selected="mudaDataFinal"
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="danger" class="mt-3 botao" @click="goBack()">Cancelar</b-button>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="success" class="mt-3 botao" @click="save()">Salvar</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style>
.card-edicao > .card-body {
  padding-top: 0.25rem !important;
}
.date-input > .form-control > div > input {
  width: 100%;
  height: 100%;
  border: none;
  color: #5c6873;
}
.botao {
  width: 100% !important;
}
.input-group-text {
  width: 100px !important;
}
.form-control > input {
  width: calc(100% - 20px) !important;
  height: 100% !important;
  border: none !important;
  padding: 0 !important;
  color: #5c6873;
}
</style>


<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vuejs-timepicker";
import moment from "moment";


export default {
  name: "editar-promocao",
  components: { Loading, Datepicker, moment, VueTimepicker },
  data: function() {
    return {
      isLoading: false,
      id: null,
      promocao: null,
      cardTitle: "",
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      datainicial: new Date(),
      datafinal: new Date()
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async save() {
      this.isLoading = true;
      const options = { title: "Aviso", size: "sm" };

      if (await this.verificaDataPromocao()) {
        if (
          moment(this.promocao.datainicial).isAfter(this.promocao.datafinal)
        ) {
          this.isLoading = false;
          this.$dialogs.alert("Datas inválidas.", options).then(res => {});
        } else if (moment(this.promocao.datainicial).isAfter(Date.now())) {
          this.isLoading = false;
          this.$dialogs.alert("Datas inválidas.", options).then(res => {});
        } else if (moment(Date.now()).isAfter(this.promocao.datafinal)) {
          this.isLoading = false;
          this.$dialogs.alert("Datas inválidas.", options).then(res => {});
        } else {
          this.promocao.datainicial = moment(
            this.promocao.datainicial
          ).format();
          this.promocao.datafinal = moment(this.promocao.datafinal).format();
          await axios
            .post(
              `${config.default.servidor}/gerencial/promocao`,
              {
                id: this.promocao.id,
                titulo: this.promocao.titulo,
                descricao: this.promocao.descricao,
                datainicial: this.datainicial,
                datafinal: this.datafinal
              },
              {
                headers: {
                  Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                }
              }
            )
            .then(response => {
              this.isLoading = false;
              if (response.status == 200) {
                this.$dialogs
                  .alert("Alterado com sucesso.", options)
                  .then(res => {
                    this.$router.go(-1);
                  });
              }
            })
            .catch(error => {
              this.$dialogs.alert(`Erro: ${error}`, options).then(res => {
                console.log(res);
              });
              this.$router.go(-1);
            });
        }
      } else {
        this.isLoading = false;
        this.$dialogs
          .alert("Data final maior que a data cadastrada no sistema.", options)
          .then(res => {});
      }
    },

    async verificaDataPromocao() {
      let promise = new Promise((resolve, reject) => {
        axios
          .get(
            `${
              config.default.servidor
            }/gerencial/promocao/data/${localStorage.getItem(
              "enterprise_id"
            )}/${this.promocao.idlocal}/${moment(this.datafinal).format(
              "YYYY-MM-DD"
            )}`,
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(response => {
            if (response.status == 200) {
              resolve(true);
            } else if (response.status == 203) {
              reject(false);
            }
          });
      })
      return await promise;
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    mudaDataFinal(data) {
      if (data) {
        this.disabledDatesStart = null;
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
      }
    },
    mudaDataInicial(data) {
      if (data) {
        this.disabledDatesEnd = null;
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
      }
    }
  },

  async beforeMount() {
    this.isLoading = true;
    this.id = this.$route.params.id;
    this.cardTitle = `Promoção`;
    if (this.id == null) {
      const options = { title: "Aviso", size: "sm" };
      this.$dialogs
        .alert("Não encontramos a promoção indicada.", options)
        .then(res => {
          console.log(res);
        });
      this.$router.go(-1);
    } else {
      await axios
        .get(
          `${config.default.servidor}/gerencial/promocao/dados/${this.id}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          this.promocao = response.data.data;
          this.datainicial = new Date(this.promocao.datainicial);
          this.datafinal = new Date(this.promocao.datafinal);
          // Desabilita as datas iniciais que sejam menores do que hoje
          this.disabledDatesStart = {};
          this.disabledDatesStart.from = new Date(moment(this.datafinal));

          // Desabilita as datas finais que sejam menores ou iguais a data inicial
          this.disabledDatesEnd = {};
          this.disabledDatesEnd.to = new Date(this.datainicial);

          this.isLoading = false;
        })
        .catch(error => {
          const options = { title: "Aviso", size: "sm" };
          this.$dialogs.alert(`Erro: ${error}`, options).then(res => {
            console.log(res);
          });
          this.$router.go(-1);
        });
    }
  }
};
</script>

